import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AdminDashboard.css";

export default function AdminDashboard() {
  const navigate = useNavigate();
  const [totalProducts, setTotalProducts] = useState(0);
  const [loading, setLoading] = useState(true);
const [unreadMsgs, setUnreadMsgs] = useState(0);
const [ordersCount, setOrdersCount] = useState(0);
  const logout = () => {
    localStorage.removeItem("admin_token");
    navigate("/admin/login");
  };

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await fetch("https://api.thetotetherapy.com/api/products");
        const data = await res.json();
        setTotalProducts(data.length);
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);
  useEffect(() => {
  const fetchData = async () => {
    try {
      // Fetch products
      const productRes = await fetch("https://api.thetotetherapy.com/api/products");
      const productData = await productRes.json();
      setTotalProducts(productData.length);

      // ✅ Fetch orders
      const orderRes = await fetch("https://api.thetotetherapy.com/api/orders");
      const orderData = await orderRes.json();
      setOrdersCount(orderData.length);

    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    } finally {
      setLoading(false);
    }
  };

  fetchData();
}, []);
const fetchUnread = async () => {
  try {
    const r = await fetch("https://api.thetotetherapy.com/api/contact/unread-count");
    const d = await r.json();
    setUnreadMsgs(d.unread || 0);
  } catch (e) {
    console.error(e);
  }
};

fetchUnread();
  return (
    <div className="adminDashboard">
      {/* Sidebar */}
      <aside className="adminSidebar">
        <div className="adminSidebar__logo">
          <img src="/Tote.png" alt="Logo" />
        </div>

        <nav className="adminSidebar__nav">
          <button onClick={() => navigate("/admin/dashboard")}>
            Dashboard
          </button>
          <button onClick={() => navigate("/admin/add-product")}>
            Add Product
          </button>
          <button onClick={() => navigate("/admin/products")}>
            Manage Products
          </button>
          <button onClick={() => navigate("/admin/orders")} className="ordersBtn">
  Orders
  {ordersCount > 0 && <span className="badgeCount">{ordersCount}</span>}
</button>
          <button onClick={() => navigate("/admin/contact-messages")} className="msgBtn">
  Contact Messages
  {unreadMsgs > 0 && <span className="badgeCount">{unreadMsgs}</span>}
</button>
        </nav>

        <button className="logoutBtn" onClick={logout}>
          Logout
        </button>
      </aside>

      {/* Main */}
      <main className="adminMain">
        <header className="adminHeader">
          <h2>Admin Dashboard</h2>
          <p>Manage your products and brand easily.</p>
        </header>

        <div className="adminCards">
          {/* Total Products Card */}
          <div className="adminCard highlightCard">
            <h3>Total Products</h3>
            {loading ? (
              <p>Loading...</p>
            ) : (
              <div className="statNumber">{totalProducts}</div>
            )}
            <p>All listed tote products.</p>
          </div>

          {/* Add Product */}
          <div className="adminCard">
            <h3>Add New Product</h3>
            <p>Upload new tote items.</p>
            <button
              className="primaryBtn"
              onClick={() => navigate("/admin/add-product")}
            >
              Add Product
            </button>
          </div>

          {/* Brand Overview */}
          <div className="adminCard">
            <h3>Brand Overview</h3>
            <p>Monitor your Tote Therapy brand presence.</p>
          </div>
        </div>
      </main>
    </div>
  );
}